module.exports = __webpack_public_path__ + "static/media/kits-image-2.dfa2d058.png";